import { render } from "./QuestionAnswer.vue?vue&type=template&id=b3badb52&scoped=true"
import script from "./QuestionAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAnswer.vue?vue&type=script&lang=js"

import "./QuestionAnswer.vue?vue&type=style&index=0&id=b3badb52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3badb52"]])

export default __exports__